import { hasPath } from "ramda";
import React from "react";

import { GridRow } from "src/common/components/Grid";
import { ColumnRenderer } from "src/features/forms/components/ColumnRenderer";
import { FormContext } from "src/features/forms/context/FormContext";
import { NodeContext } from "src/features/forms/context/NodeContext";
import { RowData } from "src/features/forms/types";

export const RowRenderer: React.FunctionComponent<RowData> = React.memo(
	({ columns }) => {
		const { value } = React.useContext(FormContext);
		const { path: rootPath } = React.useContext(NodeContext);
		const shouldRender = React.useMemo(
			() =>
				columns.some(column => {
					const path = [...rootPath, ...column.field.path];
					return (
						path.length === 0 || hasPath(path as string[], value)
					);
				}),
			[value, rootPath, columns]
		);
		if (!shouldRender) {
			return null;
		}
		return (
			<GridRow>
				{columns.map((props, key) => (
					<ColumnRenderer key={key} {...props} />
				))}
			</GridRow>
		);
	}
);
